export type UseGoogleFonts = {
  enabled: boolean;
  slug: string;
}

export function useGoogleFonts({ enabled, slug }: UseGoogleFonts) {
  if (!enabled) {
    return <></>
  }

  const themeFamilies = [
    {
      id: 'cbn',
      families: [0, 2]
    },
    {
      id: 'cbngo',
      families: [0, 2]
    },
    {
      id: 'cbnto',
      families: [0, 2]
    },
    {
      id: 'daqui',
      families: [0, 3]
    },
    {
      id: 'opopular',
      families: [0]
    },
    {
      id: 'tocantins',
      families: [0, 1]
    }
  ]

  const avbFamilies = [
    {
      id: 'Fira Sans Condensed',
      weights: [300, 400, 500, 600, 700],
      param: 'family=Fira+Sans+Condensed:wght@',
    },
    {
      id: 'IBM Plex Sans Condensed',
      weights: [300, 400, 500, 600, 700],
      param: 'family=IBM+Plex+Sans+Condensed:wght@',
    },
    {
      id: 'Roboto Slab',
      weights: [300, 400, 500, 600, 700],
      param: 'family=Roboto+Slab:wght@',
    },
    {
      id: 'Roboto Condensed',
      weights: [300, 400, 700],
      param: 'family=Roboto+Condensed:wght@',
    }
  ]

  const selectedFromThemeFamilies = themeFamilies.find((i) => i.id === slug)

  const selectedFromAvbFamilies: Array<any> = []
  selectedFromThemeFamilies?.families && selectedFromThemeFamilies?.families.map((i) => avbFamilies[i] && selectedFromAvbFamilies.push(avbFamilies[i]))

  const finalStringParam: Array<string> = []
  selectedFromAvbFamilies.map((i) => finalStringParam.push(`${i.param}${i.weights.join(';')}`))

  return (
    <>
      <link rel='preconnect' href='https://fonts.googleapis.com' />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='true' />
      <link href={`https://fonts.googleapis.com/css2?${finalStringParam.join('&')}&display=swap`} rel='stylesheet' />
    </>
  )
}